import ParentData from './ParentData'

export default ParentData
